<div class="flex flex-wrap justify-between items-center gap-2 fixed bottom-0 z-40 w-full sm:px-4 px-2 py-3 bg-gray-50 border-t border-default shadow-sm print:hidden">
  <div class="sm:flex grid grid-cols-2 items-center gap-2 sm:w-auto w-full">
    @if (appStore.cart().snapshot) {
      <app-button variant="secondary" title="Clear cart and start over" (click)="startOver()">
        <div class="flex items-center gap-1 justify-center">
          <app-icons icon="rotate-left" svgClass=""/>Start Over
        </div>
      </app-button>
    } @else {
      <app-button href="results" title="Return to results" variant="secondary">
        <div class="flex items-center gap-1 justify-center">
          <app-icons icon="arrow-left" svgClass=""/> Back
        </div>
      </app-button>
    }

    @if (access.has('save_for_later')) {
      <div class="md:hidden">
        <app-button (click)="saveForLater.emit()" [title]="access.getTitle('save_for_later', 'Save for later')" variant="secondary" [disabled]="access.cannot('save_for_later')">
          <div class="flex items-center gap-1 justify-center">
            <app-icons icon="floppy-disk" svgClass=""></app-icons>Save for Later
          </div>
        </app-button>
      </div>
    }
  </div>

  <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:w-auto w-full">
    @if (access.has('save_for_later')) {
      <div class="hidden md:block">
        <app-button id="compare-save-for-later" (click)="saveForLater.emit()" [title]="access.getTitle('save_for_later', 'Save for later')" variant="secondary" [disabled]="access.cannot('save_for_later')">
          <div class="flex items-center gap-1 whitespace-nowrap">
            <app-icons icon="floppy-disk" svgClass=""></app-icons>
            Save for Later
          </div>
        </app-button>
      </div>
    }

    <div class="flex sm:inline-flex items-center bg-white border border-gray-200 rounded-sm px-2 py-2" (mouseleave)="onStepLeave()">
      <span class="text-xs font-semibold text-gray-500 ps-1 pe-2 whitespace-nowrap">Add to:</span>

        @for (step of visibleSteps(); track step.key; let idx = $index; let isLast = $last) {
          @let disabled = isStepDisabled(step.key);

          <button
            type="button"
            id="compare-{{step.key}}"
            [disabled]="disabled"
            [title]="getStepTitle(step)"
            class="inline-flex items-center justify-center gap-1.5 h-[25px] px-2 rounded-sm text-xs font-semibold whitespace-nowrap transition-colors flex-1 sm:flex-none border-0 not-disabled:cursor-pointer disabled:text-fg-disabled disabled:bg-disabled"
            [class.bg-brand]="idx <= displayStepIndex()"
            [class.text-white]="idx <= displayStepIndex()"
            [class.text-gray-900]="idx > displayStepIndex()"
            (mouseenter)="onStepHover(step.key)"
            (click)="select(step.key)">
            <app-icons [icon]="step.icon" width="14px"></app-icons>
            {{ step.label }}
          </button>
          @if (!isLast) {
            <div
              class="h-px w-3.5 shrink-0 bg-white"
              [class.bg-brand!]="idx < displayStepIndex() && !isStepDisabled(visibleSteps()[idx + 1].key)">
            </div>
          }
        }
    </div>

    <div class="w-full">
      <app-button id="compare-confirm" [disabled]="confirmDisabled()" (click)="onConfirm.emit(displayStep())" [title]="confirmTitle()">
        <div class="flex items-center justify-center gap-1">
          <app-icons icon="check" svgClass=""></app-icons>
          Confirm
        </div>
      </app-button>
    </div>
  </div>
</div>
